/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AutocompleteAddressResponse as ModelsCustomerAutocompleteAddressResponse } from '../../models/Models/Customer/autocomplete-address-response';

export interface V3AddressesGet$Xml$Params {
  query?: string;
}

export function v3AddressesGet$Xml(http: HttpClient, rootUrl: string, params?: V3AddressesGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsCustomerAutocompleteAddressResponse>> {
  const rb = new RequestBuilder(rootUrl, v3AddressesGet$Xml.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsCustomerAutocompleteAddressResponse>;
    })
  );
}

v3AddressesGet$Xml.PATH = '/v3/addresses';
